import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import type { Theme } from '../theme';

export type BadgeVariant = 'neutral' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';

export interface BadgeProps {
  variant?: BadgeVariant;
  dot?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const tones = (t: Theme) => ({
  neutral:   css`background: ${t.color.bg.muted};   color: ${t.color.fg.muted};`,
  primary:   css`background: ${t.color.blue[50]};   color: ${t.color.blue[700]};`,
  secondary: css`background: ${t.color.violet[50]}; color: ${t.color.violet[700]};`,
  success:   css`background: ${t.color.green[50]};  color: ${t.color.green[700]};`,
  warning:   css`background: ${t.color.amber[50]};  color: ${t.color.amber[700]};`,
  danger:    css`background: ${t.color.red[50]};    color: ${t.color.red[700]};`,
});

const Root = styled.span<{ $variant: BadgeVariant }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: ${({ theme }) => theme.fontWeight.semibold};
  line-height: 1.4;
  ${({ theme, $variant }) => tones(theme)[$variant]}
`;
const Dot = styled.span`width: 6px; height: 6px; border-radius: 999px; background: currentColor;`;

/** Lumen badge — compact status pill. Add `dot` for a leading status dot. */
export function Badge({ variant = 'neutral', dot, children, className }: BadgeProps) {
  return (
    <Root $variant={variant} className={className}>
      {dot && <Dot />}
      {children}
    </Root>
  );
}
